import FiltersBarSkeletonImpl from './filters-bar-skeleton.js';
import MojitoCore from 'mojito/core';

const UIView = MojitoCore.Presentation.UIView;

/**
 * Skeleton component to represent a loading filters bar.
 *
 * @function FiltersBarSkeleton
 * @memberof Mojito.Presentation
 */

export default UIView('FiltersBarSkeleton', FiltersBarSkeletonImpl);
